import React from 'react'

export default function HorizentalSpacer() {
    return (
        <div className='horizentalSpacer border-success bg-success my-4 mx-auto' />
    )
}
